import Alert from "@mui/material/Alert";
import { forwardRef } from "react";

const AlertComponent = forwardRef(function AlertComponent(props, ref) {
  const { message, variant, ...rest } = props;
  return (
    <Alert ref={ref} severity={variant} {...rest}>
      {message}
    </Alert>
  );
});

export default AlertComponent;
